import Immutable from 'immutable';
import {
  recalculateAutomaticDates,
  removeRelease,
  sortState,
} from './reducer_functions';

export default function (state, action) {
  let masterRelease, masterReleaseIndex, release, releaseIndex, releases;
  switch (action.type) {
    case 'HYDRATE':
      return action.payload.data;
    case 'ALL_RELEASES':
      var newState = state.set('releases', action.payload.releases);
      recalculateAutomaticDates(newState);
      if (action.payload.bookmark) {
        return newState.set('bookmark', action.payload.bookmark);
      }
      break;

    case 'REMOVE_RELEASE':
      removeRelease(state.get('bookmark').get('id'), action.payload.releaseId);
      if (action.payload.masterReleaseId) {
        masterRelease = state
          .get('releases')
          .find(
            release => release.get('id') === action.payload.masterReleaseId
          );
        masterReleaseIndex = state.get('releases').indexOf(masterRelease);

        releases = state
          .get('releases')
          .get(masterReleaseIndex)
          .get('subReleases')
          .filterNot(release => release.get('id') === action.payload.releaseId);
        newState = state.setIn(
          ['releases', masterReleaseIndex, 'subReleases'],
          releases
        );
      } else {
        releases = state
          .get('releases')
          .filterNot(release => release.get('id') === action.payload.releaseId);
        newState = state.set('releases', releases);
      }

      return recalculateAutomaticDates(newState);

    case 'UPDATE_RELEASE_REMOTELY':
      if (!action.payload.release) {
        return state;
      }

      // Find the roll-up release
      masterRelease =
        action.payload.release.parentReleaseId &&
        state
          .get('releases')
          .find(
            release =>
              release.get('id') === action.payload.release.parentReleaseId
          );

      // If the release has a roll-up release, but we can't find it, treat it as a regular release.
      // This can happen when the release is attached to a roll-up release from a different tab.
      if (action.payload.release.parentReleaseId && !masterRelease) {
        // There are a few places where we assume that if a release is a sub-release then the roll-up release
        // is also present so setting this to false makes the release behave as a regular release.
        action.payload.release.subRelease = false;
      }

      if (masterRelease) {
        masterReleaseIndex = state.get('releases').indexOf(masterRelease);

        const subReleases = state
          .get('releases')
          .get(masterReleaseIndex)
          .get('subReleases');
        release = subReleases.find(
          release => release.get('id') === action.payload.release.id
        );
        releaseIndex = subReleases.indexOf(release);

        newState = state.setIn(
          ['releases', masterReleaseIndex, 'subReleases', releaseIndex],
          Immutable.fromJS(action.payload.release)
        );
      } else {
        release = state
          .get('releases')
          .find(release => release.get('id') === action.payload.release.id);
        releaseIndex = state.get('releases').indexOf(release);
        newState = state.setIn(
          ['releases', releaseIndex],
          Immutable.fromJS(action.payload.release)
        );
      }

      newState = sortState(newState);
      return recalculateAutomaticDates(newState);

    default:
      return state;
  }
}
